module.exports = __webpack_public_path__ + "248c68fec2c93511894be90837c12fff.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/Foto_Manja_Herrmann-8484.jpg
// module id = 461
// module chunks = 0